import React, { Component } from 'react'
import { Row, Col, Panel } from 'react-bootstrap'
import { array, number, object } from 'prop-types'
import _ from 'lodash'

class ABTestRound extends Component {
  constructor () {
    super()

    this.state = {}

    this.getThumbnailById = this.getThumbnailById.bind(this)
  }
  getThumbnailById (id) {
    let { thumbnails } = this.props
    let thumb = _.find(thumbnails, { id })
    return <img width={218} height={117} alt='' src={thumb.url} />
  }
  render () {
    const { round, index } = this.props

    return (
      <Row>
        <Col md={12}>
          <Panel header={`Round ${index + 1}`}>
            <Col md={6}>
              <Panel header='A'>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Thumbnail selecionado:</label>
                    {this.getThumbnailById(round.a.thumbnail_id)}
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Nome da versão:</label>
                    <p>{round.a.name}</p>
                  </div>
                  <label>Distribuição:</label> {round.a.distribution}%
                  <button className='btn btn-success mt10'>Declarar vencedor</button>
                </Col>
              </Panel>
            </Col>
            <Col md={6}>
              <Panel header='B'>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Selecione o thumbnail:</label>
                    {this.getThumbnailById(round.b.thumbnail_id)}
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group'>
                    <label>Nome da versão:</label>
                    <p>{round.b.name}</p>
                  </div>
                  <label>Distribuição:</label> {round.b.distribution}%
                  <button className='btn btn-success mt10'>Declarar vencedor</button>
                </Col>
              </Panel>
            </Col>
          </Panel>
        </Col>
      </Row>
    )
  }
}

ABTestRound.propTypes = {
  thumbnails: array.isRequired,
  index: number.isRequired,
  round: object.isRequired
}

export default ABTestRound



// WEBPACK FOOTER //
// ./src/components/ABTestRound.js